import {
    useSelector,
    abonnementsActions,
    abonnementsUsersActions,
    membershipActions,
    paymentsActions,
    webFEActions
} from "inbooma-api";
import {Biscuit} from "../../../../../../utils";
import t from "../../../../../helpers/t";
import {moment} from "../../../../../../../vendor";
import React, {useEffect, useState} from "react";
import {in_array} from "../../../../../../utils/Helper";
import FormItem from "../../../../../components/FormItem";

const AbonnementsSelect = (props) => {
    const { user, setUser, dispatch, _editUser, setFormError, formError, showNotification, language } = props;

    const originAbonnementsUsers = user.abonnements_users;
    const [showPaymentMethods, setShowPaymentMethods] = useState(false);

    const _abonnementUserAdd = useSelector(state => state.abonnements_users_data.addAbonnementsUser);
    const _abonnementUserDelete = useSelector(state => state.abonnements_users_data.deleteAbonnementsUser);
    const _memberships = useSelector(state => state.memberships_data.memberships);
    const _abonnements = useSelector(state => state.abonnements_data.getAbonnements);
    const _payments = useSelector(state => state.payments_data.activeRecurringPaymentMethods);
    const _webFEAU = useSelector(state => state.web_fe_data.webFE_items);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [usedPaymentMethod, setUsedPaymentMethod] = useState(null);
    const [abonnementUserPending, setAbonnementUserPending] = useState(null);
    const [abonnementsResults, setAbonnementsResults] = useState([]);
    const [abonnementsResultsHidden, setAbonnementsResultsHidden] = useState(true);
    const [membershipsPending, setMembershipsPending] = useState(false);

    useEffect( () => {
        if(_webFEAU !== {} && typeof _webFEAU.data !== 'undefined' && _webFEAU.data.length > 0){
            _webFEAU.data.map(item => {
                if(item.app === null || item.data.user_id === user.id && item.model === 'AbonnementsUsers'){
                    let clone = {};
                    Object.assign(clone,user);
                    clone.abonnements_users.map((val,k) => {
                        if(val.abonnement_id === item.data.abonnement_id){
                            clone.abonnements_users[k].id = item.id;
                        }
                    })
                    setUser(clone);
                    dispatch(membershipActions.getMemberships({
                        token: Biscuit.get('token'),
                        filter: {
                            user_id: user.id
                        }
                    }));
                    setMembershipsPending(true);
                    dispatch(webFEActions.removeWebFEItemById({id:item._id}));
                }
            })
        }
    },[_webFEAU]);

    useEffect(() => {
        if(_abonnements.success === '' && _payments.success === ''){
            if(typeof user.id !== 'undefined'){
                dispatch(paymentsActions.getActiveRecurringPaymentMethods(
                    {
                        token: Biscuit.get('token'),
                        user_id: user.id
                    }
                ));
                dispatch(abonnementsActions.getAbonnements({
                    token: Biscuit.get('token'),
                    filter: {
                        'limit': '999',
                        'sort': 'description',
                        'sortDirection': 'asc'
                    }
                }));
            }
        }
    },[]);



    useEffect(() => {
        if(_memberships.success === '' || !membershipsPending) return;
        if(_memberships.success === true){
            let clone = {};
            Object.assign(clone, user);
            clone.memberships = _memberships.data;
            setUser(clone);
        }
        setMembershipsPending(false);
    }, [_memberships]);

    useEffect(() => {
        if(_abonnementUserAdd.success === '' || abonnementUserPending === null) return;
        if(_abonnementUserAdd.success === true){
            showNotification('success', null, null, 'abonnement');
        }else {

            let message = '';
            if (_abonnementUserAdd.data.errors) {
                let formErrorClone = {...formError};
                Object.keys(_editUser.data.errors).forEach(key => {
                    const errorObj = _abonnementUserAdd.data.errors[key];
                    Object.keys(errorObj).forEach(innerKey => {
                        const errorMessage = errorObj[innerKey];
                        message += `${key}: ${errorMessage}\n`;
                        formErrorClone[key] = errorMessage;
                        setFormError(formErrorClone);
                        /* console.log(innerKey); */
                    });
                });
            } else {
                message = _editUser.data.message;
            }
            showNotification('warning', user.id, message, 'abonnement');
            user.abonnements_users.splice(abonnementUserPending, 1);
        }
        setAbonnementUserPending(null);
    }, [_abonnementUserAdd]);

    useEffect(() => {
        if(_abonnementUserDelete.success === '' || abonnementUserPending === null) return;
        if(_abonnementUserDelete.success === true){
            showNotification('success', null, null, 'abonnement',false,true);
            user.abonnements_users.splice(abonnementUserPending, 1);
            dispatch(membershipActions.getMemberships({
                token: Biscuit.get('token'),
                filter: {
                    user_id: user.id
                }
            }));
            setMembershipsPending(true);
        }else {

            let message = '';
            if (_abonnementUserDelete.data.errors) {
                let formErrorClone = {...formError};
                Object.keys(_editUser.data.errors).forEach(key => {
                    const errorObj = _abonnementUserDelete.data.errors[key];
                    Object.keys(errorObj).forEach(innerKey => {
                        const errorMessage = errorObj[innerKey];
                        message += `${key}: ${errorMessage}\n`;
                        formErrorClone[key] = errorMessage;
                        setFormError(formErrorClone);
                        /* console.log(innerKey); */
                    });
                });
            } else {
                message = _editUser.data.message;
            }
            showNotification('warning', user.id, message, 'userAbonnement');
        }
        setAbonnementUserPending(null);
    }, [_abonnementUserDelete]);


    useEffect(() => {

        if (_abonnements.success === true) {
            let contain = [];
            for (let e = 0; e < _abonnements.data.length; e++) {
                if (in_array(_abonnements.data[e].id, contain)) {
                    delete (_abonnements.data[e]);
                    continue;
                }
                contain.push(_abonnements.data[e].id);
            }
            setAbonnementsResults([..._abonnements.data]);
        }
    }, [_abonnements]);

    useEffect(() => {
        if(_payments.success === '') return;
        if(_payments.success === true){
            let payments = [];
            if(_payments.data['paypal'].BILLINGAGREEMENTID !== false && _payments.data['paypal']?.BILLINGAGREEMENTSTATUS === 'active'){
                payments.push({
                    'name': t('paypal'),
                    'value': 'paypal'
                });
            }
            if(_payments.data.credit?.data?.length > 0){
                payments.push({
                    'name': t('credit'),
                    'value': 'card'
                });
            }
            if(_payments.data.sepa_debit?.data?.length > 0){
                payments.push({
                    'name': t('sepa_debit'),
                    'value': 'sepa_debit'
                });
            }
            console.log(payments);
            setPaymentMethods(payments);
        }
    }, [_payments]);
    const saveAbonnement = (index, abonnement) => {
        if(typeof abonnement.id === 'undefined') {
            dispatch(abonnementsUsersActions.addAbonnementsUser({
                id: user.id,
                body: abonnement,
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        "Accept-Language": language,
                        "Content-Language": language
                    }
                }
            }));
            setAbonnementUserPending(index);
        }
    };

    const isAbonnementSelected = (id) => {

        for (let i = 0; i < user.abonnements_users.length; i++) {
            if (user.abonnements_users[i].abonnement_id === id) return true;
        }
        return false;
    };

    const onChangePaymentMethod = (e) => {
        let clone = {};
        Object.assign(clone,user);
        clone.abonnements_users.map((val,k) => {
            clone.abonnements_users[k].paymentMethod = e.target.value;
            saveAbonnement(k,val);
        });
        setUser(clone);
        setUsedPaymentMethod(e.target.value);
    }
    const onAbonnementRemove = (e, abonnement, index) => {
        console.log(abonnement, 'abonnementOnRemove')
        if(typeof abonnement.membership_types_id !== 'undefined'){
            user.abonnements_users.map(val => {
                if(val.abonnement_id === abonnement.id){
                    abonnement = val;
                }
            });
        }
        console.log(abonnement, 'abonnementOnRemove')
        let bestaetigung = window.confirm(t('Do you really want to remove this abonnement? Payments collected will not be refunded.'));
        if (bestaetigung) {
            dispatch(abonnementsUsersActions.deleteAbonnementsUser(
                {
                    token: Biscuit.get('token'),
                    id: abonnement.id
                }
            ));
            setAbonnementUserPending(index);
        }

    };

    const onAbonnementSearchBlur = (e) => {
        setTimeout(() => {
            setAbonnementsResultsHidden(true);
            document.getElementsByClassName('select2-search__field3')[0].value = "";
        }, 200);
    };

    const onAbonnementSearchClicked = (e) => {
        document.getElementsByClassName('select2-search__field3')[0].style.width = "9em";
        document.getElementsByClassName('select2-search__field3')[0].focus();
        setAbonnementsResults([..._abonnements.data]);
        setAbonnementsResultsHidden(false);
    };

    const onAbonnementSearchChanged = (e) => {

        const value = e.target.value;
        let results = [];
        if (value.length == 0) {
            setAbonnementsResults([..._abonnements.data]);
        } else {
            results = [];
            // search for locations with name starting with query (value)
            for (var i = 0; i < _abonnements.data.length; i++) {
                if (_abonnements.data[i].description.toLowerCase().startsWith(value)) results.push(_abonnements.data[i]);
            }
            setAbonnementsResults(results);
        }
    };
    const onAbonnementsSelectHandle = (e, abonnement) => {
        // add selection to array if not already selected
        if (!e.target.parentNode.classList.contains("selected")) {
            let clone = {};
            Object.assign(clone,user);
            clone.abonnements_users.push({
                abonnement_id: abonnement.id,
                user_id: user.id,
                cancelled: null,
                begin: moment().format("YYYY-MM-DD HH:mm:ss"),
                abonnement: abonnement,
                paymentMethod: usedPaymentMethod
            });
            setUser(clone);
            if(clone.abonnements_users.length !== 0){
                setShowPaymentMethods(true);
                if(usedPaymentMethod){
                    clone.abonnements_users.map((val,k) => {
                        if(val.abonnement_id === abonnement.id){
                            saveAbonnement(k,val);
                        }
                    });
                }
            } else {
                setShowPaymentMethods(false);
            }
        };
    };

    return (<> <div className="inb-form-group column medium-12 small-12 _backform_userfroups">
        <label
            className="inb-form__controlLabel">{t('abonnements', null, 'capital')}</label>
        {paymentMethods.length > 0 ? <>
            <div className="inb-form__controllClass">
                                    <span
                                        className="select2 select2-container select2-container--default select2-container--focus"
                                        dir="ltr" data-select2-id="2" style={{ width: 'auto' }}>
                                        <span className="selection">
                                            <span className="select2-selection select2-selection--multiple" role="combobox"
                                                  aria-haspopup="true" aria-expanded="false" tabIndex="-1">
                                                <ul className="select2-selection__rendered"
                                                    onClick={onAbonnementSearchClicked}>
                                                    {user.abonnements_users.map((abonnement, index) => {
                                                        if (typeof abonnement.abonnement_id !== 'undefined') {
                                                            return (<>
                                                                    <li className="select2-selection__choice" title={abonnement.abonnement.description}>
                                                                    <span className="select2-selection__choice__remove"
                                                                          role="presentation" onClick={(e) => {
                                                                        onAbonnementRemove(e, abonnement, index)
                                                                    }}>×</span>
                                                                        {abonnement.abonnement.description} ( {(typeof abonnement.id === 'undefined')?"Wird geprüft":(abonnement.cancelled !== null)?"Inaktiv":"Aktiv"} )
                                                                    </li>
                                                                </>
                                                            );
                                                        }
                                                    })}

                                                    <li className="select2-search select2-search--inline" style={{ paddingTop: "5px" }}>
                                                        <input className="select2-search__field3" type="search" tabIndex="0"
                                                               autoComplete="off" autoCorrect="off" autoCapitalize="none"
                                                               spellCheck="false"
                                                               role="textbox" aria-autocomplete="list" placeholder={t('switch')}
                                                               onChange={onAbonnementSearchChanged}
                                                               onBlur={onAbonnementSearchBlur} />
                                                    </li>
                                                </ul>
                                            </span>
                                        </span>
                                        <ul className={'inbooma-select-box-results' + (abonnementsResultsHidden === true ? ' hide' : '')}
                                            style={{ width: '100%' }}>
                                            {abonnementsResults.map(abonnement => {
                                                return (
                                                    <li className={"inbooma-select-box-results__field" + (isAbonnementSelected(abonnement.id) ? ' selected' : '')}
                                                        key={abonnement.id} value={abonnement.id}
                                                        onClick={(e) => {
                                                            onAbonnementsSelectHandle(e, abonnement)
                                                        }}>
                                                        <span style={{ width: '100%' }}>{abonnement.description}</span>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </span>
            </div>
            {showPaymentMethods &&   <FormItem
                name="paymentMethod"
                inputType="select"
                id={"users_payment_method_"+(typeof user.id !== 'undefined'?user.id:'new')}
                label={t('payment method for abonnement',null,'capital')}
                type="select"
                dataKey="value"
                nameAttribute="name"
                data={paymentMethods}
                selected={user.abonnements_users.length > 0 ? user.abonnements_users[0].paymentMethod:0}
                mediumWidth={6}
                smallWidth={12}
                onChangeHandler={onChangePaymentMethod}
                placeholder={t('please_select')}
                extraTopClasses="client_select"/>}
        </>:<>
            <label
                className="inb-form__controlLabel">{t('no paymentmethods configured', null, 'capital')}</label>
        </>}
    </div></>);
}

export default AbonnementsSelect;